const klageSitePaths = {
  shortUrl: "/klage",
  page: "/klage/:path",
  rediger: "/klage/bilder/:id/rediger",
  miljogebyrer: {
    shortUrl: "/klage/miljogebyrer",
    detalj: {
      matcher:
        "/klage/miljogebyrer/[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}$",
      route: "/klage/miljogebyrer/:id",
      getUrl: (miljogebyrId) => `/klage/miljogebyrer/${miljogebyrId}`,
      utskrift: "/klage/miljogebyrer/:id/utskrift",
      rediger: "/klage/miljogebyrer/:id/bilder/:bildeId/rediger",
      bilde: "/klage/miljogebyrer/:id/bilder/:bildeId",
      miljokontroll: {
        matcher:
          "/klage/miljogebyrer/[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}/tidskontroller/[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}$",
        route: "/klage/miljogebyrer/:miljogebyrId/tidskontroller/:id",
        getUrl: (miljogebyrId, miljokontrollId) =>
          `/klage/miljogebyrer/${miljogebyrId}/tidskontroller/${miljokontrollId}`,
        rediger:
          "/klage/miljogebyrer/:id/tidskontroller/:miljokontrollId/observasjoner/:observasjonId/bilder/:bildeId/rediger",
        bilde:
          "/klage/miljogebyrer/:id/tidskontroller/:miljokontrollId/observasjoner/:observasjonId/bilder/:bildeId",
      },
    },
  },
  ileggelser: {
    shortUrl: "/klage/ileggelser",
    detalj: {
      shortUrl: "/klage/ileggelser/:id",
      utskrift: "/klage/ileggelser/:id/utskrift",
      rediger: "/klage/ileggelser/:id/bilder/:bildeId/rediger",
      bilde: "/klage/ileggelser/:id/bilder/:bildeId",
    },
  },
  default: "/klage",
};

export default klageSitePaths;
